export const environment = {
  production: true,
  mockup: false,

  CPS2_DOMAIN: 'https://cps-preprod.pharmacists.ca',
  CPHA_AUTH_ENDPOINT: 'https://hub-preprod.pharmacists.ca/cpha-auth',
  COMMONS_API_ENDPOINT: 'https://preprod.commonwebservices.ca/cpha-commons-rest-ws',
  CPS_URL: 'https://cps-preprod.pharmacists.ca/assets/tokens-receiver.html',
  HUB_ORIGIN: 'https://hub-preprod.pharmacists.ca'
};
